import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import PlusMinus from "../Components/PlusMinus";
import { ReactComponent as AddToCartBtn } from "../Images/add_to_cart_btn.svg";
import { ReactComponent as IconCross } from "../Images/icon_cross.svg";
import { ReactComponent as IconGiftbox } from "../Images/icon_giftbox.svg";
import { ReactComponent as IconSearch } from "../Images/icon_search.svg";
import { ReactComponent as RightBracket } from "../Images/right_bracket.svg";
import Layout from "../Layout/Layout";
import Pagination from "../Layout/Pagination";
import AlarmSimpleOk from "../Modals/AlarmSimpleOk";
import GifticonSelect from "../Modals/GifticonSelect";
import "../Styles/component.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils";
import { showToast } from "../Utils/variables";

const GifticonContent = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [alarmState, setAlarmState] = useState({ show: false, type: "" });
  const [page, setPage] = useState(1);
  const offset = 12;
  const [searchTitle, setSearchTitle] = useState("");
  const [total_gifticon, setTotal_gifticon] = useState(0);
  const [gifticon_list, setGifticon_list] = useState([]);
  const [quantity, setQuantity] = useState(); // 임시 quantity

  const [total_cart, setTotal_cart] = useState(0);
  const [cart_list, setCart_list] = useState([]);
  const [total_cost, setTotal_cost] = useState(0);

  const [goodsCode, setGoodsCode] = useState("");
  const [gifticonCartIdArr, setGifticonCartIdArr] = useState(
    location.state?.gifticonCartIdArr || []
  );

  const [clickInput, setClickInput] = useState(false);
  const [clickItem, setClickItem] = useState(false);
  const lastGifticonRequestKey = useRef(null);
  const hasLoadedCart = useRef(false);

  const handleAddToCart = async (quantity, goodsCode) => {
    try {
      const body = { goodsCode, quantity };
      const res = await postJson("/dashboard/gifticonCart/create", body, navigate);

      if (res.code === 200) {
        await getCartList();
        // const addedItem = cart_list.find(
        //   (item) => item.goodsCode === goodsCode
        // );
        // if (addedItem) {
        //   setGifticonCartIdArr((prev) =>
        //     prev.includes(addedItem.gifticonCartId)
        //       ? prev
        //       : [...prev, addedItem.gifticonCartId]
        //   );
        // }
        setClickItem(false);
        // window.location.reload();
        showToast("기프티콘이 장바구니에 담겼습니다.", "success");
      }
    } catch (error) {
      console.error("장바구니 담기 중 에러:", error);
    }
  };

  const handleClickItem = (goodsCode) => {
    setClickItem(true);
    setGoodsCode(goodsCode);
  };

  const handleClickOrder = () => {
    if (total_cart === 0) {
      setAlarmState({ show: true, type: "emptyCart" });
    } else {
      navigate("/gifticon/order", { state: { gifticonCartIdArr } });
    }
  };

  const handleClickDeleteItem = () => {
    if (gifticonCartIdArr.length === 0) {
      setAlarmState({ show: true, type: "notSelected" });
    } else {
      deleteItem();
    }
  };

  const getGifticonList = async () => {
    try {
      const body = {
        page: page,
        offset: offset,
        searchTitle: searchTitle,
      };

      const data = await postJson("/dashboard/gifticon/getList", body, navigate);

      if (data.code === 200) {
        setTotal_gifticon(data.data.count);
        setGifticon_list(data.data.rows);
      }
    } catch (error) {
      console.log("기프티콘 리스트 가져오기 중 에러:", error);
      throw error;
    }
  };

  const calculateTotalCost = () => {
    const filtered_list = cart_list.filter((data) =>
      gifticonCartIdArr.includes(data.gifticonCartId)
    );

    const total = filtered_list.reduce(
      (acc, data) => acc + data.salePrice * data.quantity,
      0
    );
    setTotal_cost(total);
  };

  const getCartList = async () => {
    try {
      const res = await postJson("/dashboard/gifticonCart/getList", {}, navigate);

      if (res.code === 200) {
        setTotal_cart(res.data.count);
        setCart_list(res.data.rows);
        const newGifticonCartIdArr = new Set(gifticonCartIdArr);

        res.data.rows.forEach((item) => {
          newGifticonCartIdArr.add(item.gifticonCartId);
        });

        setGifticonCartIdArr([...newGifticonCartIdArr]);
        calculateTotalCost();
      }
    } catch (error) {
      console.error("장바구니 리스트 가져오기 중 에러:", error);
    }
  };

  const deleteItem = async (idArr = []) => {
    try {
      const body =
        idArr.length === 0 ? { gifticonCartIdArr } : { gifticonCartIdArr: idArr };

      const res = await postJson("/dashboard/gifticonCart/delete", body, navigate);

      if (res.code === 200) {
        window.location.reload();
      }
    } catch (error) {
      console.error("장바구니 삭제 중 에러:", error);
    }
  };

  const selectAll = () => {
    cart_list.map((data) =>
      setGifticonCartIdArr((prev) =>
        gifticonCartIdArr.includes(data.gifticonCartId)
          ? [...prev]
          : [...prev, data.gifticonCartId]
      )
    );
  };
  const removeAll = () => {
    cart_list.map((data) =>
      setGifticonCartIdArr((prev) =>
        prev.filter((item) => item !== data.gifticonCartId)
      )
    );
  };

  useEffect(() => {
    const requestKey = JSON.stringify({ page, searchTitle });

    if (lastGifticonRequestKey.current === requestKey) {
      return;
    }

    lastGifticonRequestKey.current = requestKey;
    getGifticonList();
  }, [page]);

  useEffect(() => {
    if (hasLoadedCart.current) {
      return;
    }

    hasLoadedCart.current = true;
    getCartList();
  }, []);

  useEffect(() => {
    calculateTotalCost();
  }, [cart_list, gifticonCartIdArr, quantity]);

  return (
    <div>
      {/* 기프티콘샵 박스 */}
      {clickItem && (
        <GifticonSelect
          handleClickX={() => setClickItem(false)}
          handleAddToCart={handleAddToCart}
          goodsCode={goodsCode}
        />
      )}
      {alarmState.show && (
        <AlarmSimpleOk
          title={
            alarmState.type === "emptyCart"
              ? "장바구니가 비어있습니다."
              : "선택된 상품이 없습니다."
          }
          description={
            alarmState.type === "emptyCart"
              ? "장바구니에 상품을 담아주세요."
              : "상품을 선택해주세요."
          }
          handleClickX={() => setAlarmState({ show: false, type: "" })}
        />
      )}
      <GifticonBox>
        {/* 왼쪽 area */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div className="title-in-box">기프티콘샵</div>
          {/* 검색창 */}
          <div
            className="searchBox"
            style={{
              marginTop: "20px",
              boxShadow: clickInput ? "inset 0 0 0 1px #1167ed" : "",
            }}
          >
            <input
              type="text"
              placeholder="브랜드명, 기프티콘명"
              onChange={(e) => setSearchTitle(e.target.value)}
              onClick={() => setClickInput(true)}
              onBlur={() => setClickInput(false)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  getGifticonList();
                }
              }}
            />
            <IconSearch
              style={{ cursor: "pointer" }}
              onClick={getGifticonList}
            />
          </div>
          {/* 전체상품 개수 */}
          <div className="hrz-wrapper" style={{ marginTop: "30px" }}>
            <div className="medium-text">전체상품&nbsp;</div>
            <div className="medium-text" style={{ color: "#1167ed" }}>
              {total_gifticon}
            </div>
            <div className="medium-text">개</div>
          </div>

          {/* 기프티콘 리스트 */}
          {total_gifticon === 0 ? (
            <div className="empty-box center">상품을 준비중입니다.</div>
          ) : (
            <GifticonListBox>
              {gifticon_list.slice(0, 12).map((data) => (
                <GifticonData
                  key={data.goodsCode}
                  goodsCode={data.goodsCode}
                  gifticonImg={data.goodsImgS}
                  brand={data.brandName}
                  name={data.goodsName}
                  price={data.salePrice}
                  onClickItem={(goodsCode) => handleClickItem(goodsCode)}
                />
              ))}
            </GifticonListBox>
          )}
          {/* 페이징 */}
          <div style={{ marginBottom: "30px" }}>
            <Pagination
              totalPages={
                total_gifticon === 0 ? 1 : Math.ceil(total_gifticon / 12)
              }
              currentPage={page}
              onPageChange={(pageNum) => setPage(pageNum)}
            />
          </div>
          <p style={{ fontSize: "14px", color: "#888888", marginTop: "auto" }}>
            · 기프티콘 업체에서 제공하는 기프티콘이 판매중지 될 경우를 방지하여
            랭킹마라톤에서는 주기적으로 상품 리스트 업데이트를 진행하고
            있습니다.
            <br />
            · 해당 API 업데이트로 인해 구매한 기프티콘의 상세정보가 달라질
            가능성이 있음을 명시합니다. <br />
            · 구매한 기프티콘은 1년 이내로 사용해야 합니다. 1년이 지난 후 구매
            날짜를 기준으로 순차적으로 소멸됩니다. <br />· 문의:
            info@runpoint.co.kr
          </p>
        </div>

        {/* 오른쪽 area */}
        <div style={{ marginLeft: "30px" }}>
          {/* 보유 포인트, 보유 기프티콘 */}
          <div className="storage-btn">
            <div
              style={{ display: "flex", cursor: "pointer" }}
              onClick={() =>
                navigate("/company", { state: { gifticonClick: true } })
              }
            >
              <IconGiftbox />
              <div className="medium-text" style={{ marginLeft: "2px" }}>
                기프티콘 보관함
              </div>

              <div style={{ marginLeft: "auto" }}>
                <RightBracket stroke="#888888" width="24px" height="24px" />
              </div>
            </div>
          </div>

          {/* 장바구니 */}
          <div
            className="bold-text"
            style={{ fontSize: "18px", marginTop: "30px" }}
          >
            장바구니
          </div>

          <div className="shoppingBox">
            {total_cart === 0 ? (
              <div
                className="item-area center"
                style={{ width: "347px", height: "190px", marginTop: "0px" }}
              >
                아직 담긴 상품이 없습니다
              </div>
            ) : (
              <div>
                <div>
                  <div style={{ display: "flex" }}>
                    <input
                      type="checkbox"
                      style={{ width: "20px", height: "20px" }}
                      onChange={(e) =>
                        e.target.checked ? selectAll() : removeAll()
                      }
                    />
                    <div className="bold-text" style={{ marginLeft: "4px" }}>
                      전체선택({gifticonCartIdArr.length}/{total_cart})
                    </div>
                    <div
                      className="medium-text"
                      style={{
                        marginLeft: "auto",
                        color: "#888888",
                        cursor: "pointer",
                      }}
                      onClick={handleClickDeleteItem}
                    >
                      선택삭제
                    </div>
                  </div>
                  <div
                    className="scrollView"
                    style={{
                      width: "347px",
                      height: "auto",
                      maxHeight: "721px",
                    }}
                  >
                    {cart_list.map((data) => (
                      <ShoppingBoxItem
                        key={data.gifticonCartId}
                        id={data.gifticonCartId}
                        image={data.goodsImgS}
                        brand={data.brandName}
                        name={data.goodsName}
                        price={data.salePrice}
                        quantity={data.quantity}
                        setQuantity={setQuantity}
                        setGifticonCartIdArr={setGifticonCartIdArr}
                        gifticonCartIdArr={gifticonCartIdArr}
                        deleteItem={deleteItem}
                        getCartList={getCartList}
                      />
                    ))}
                  </div>
                </div>
                <div style={{ display: "flex", marginTop: "26px" }}>
                  <div className="medium-text" style={{ color: "#555555" }}>
                    최종 결제 금액
                  </div>
                  <div
                    className="bold-text"
                    style={{
                      color: "#1167ed",
                      fontSize: "20px",
                      marginLeft: "auto",
                    }}
                  >
                    {total_cost?.toLocaleString()}원
                  </div>
                </div>
              </div>
            )}

            <div
              className="blueBtn-base center"
              style={{
                height: "60px",
                borderRadius: "10px",
                marginTop: "18px",
                cursor: "pointer",
              }}
              onClick={handleClickOrder}
            >
              주문하기
            </div>
          </div>
        </div>
      </GifticonBox>
    </div>
  );
};

const GifticonData = ({
  gifticonImg,
  goodsCode,
  brand,
  name,
  price,
  onClickItem,
}) => {
  return (
    <div style={{ marginRight: "20px" }}>
      <div style={{ width: "255.75px", height: "230px", position: "relative" }}>
        <img src={gifticonImg} style={{ width: "100%", height: "100%" }} />
      </div>
      <div className="image-hover-box center">
        <AddToCartBtn
          style={{ cursor: "pointer" }}
          onClick={() => onClickItem(goodsCode)}
        />
      </div>
      <div className="shop-text" style={{ marginTop: "18px" }}>
        {brand}
      </div>
      <div className="medium-text">{name}</div>
      <div style={{ display: "flex", marginTop: "4px" }}>
        {/* <div className="sale-text">{sale}%</div> */}
        <div className="price-text">{price?.toLocaleString()}원</div>
        {/* <div
          style={{
            color: "#6d6d6d",
            textDecoration: "line-through",
            textDecorationThickness: "1px",
            marginTop: "5px",
            marginLeft: "6px",
          }}
        >
          {price_before}P
        </div> */}
      </div>
    </div>
  );
};

const ShoppingBoxItem = ({
  id,
  image,
  name,
  brand,
  price,
  quantity,
  gifticonCartIdArr,
  setGifticonCartIdArr,
  deleteItem,
  getCartList,
}) => {
  const navigate = useNavigate();
  const [_quantity, set_Quantity] = useState(quantity);
  const [isChecked, setIsChecked] = useState(false);

  const updateQuantity = async (plusMinusValue) => {
    try {
      const body = {
        gifticonCartId: id,
        quantity: plusMinusValue,
      };

      const res = await postJson("/dashboard/gifticonCart/update", body, navigate);

      if (res.code === 200) {
        getCartList();
      }
    } catch (error) {
      console.error("수량변경 중 에러:", error);
    }
  };

  const handleSelect = () => {
    setGifticonCartIdArr((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const handleClickDeleteItem = () => {
    deleteItem([id]);
  };

  useEffect(() => {
    set_Quantity(quantity);
  }, [quantity]);
  useEffect(() => {
    if (gifticonCartIdArr.includes(id)) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  }, [gifticonCartIdArr]);

  return (
    <div className="item-area" style={{ padding: "20px" }}>
      <div style={{ display: "flex" }}>
        <input
          type="checkbox"
          style={{ width: "20px", height: "20px" }}
          checked={isChecked}
          onChange={() => handleSelect(id)}
        />
        <div
          style={{
            width: "81px",
            height: "80px",
            borderRadius: "10px",
            backgroundColor: "#d9d9d9",
            marginLeft: "16px",
          }}
        >
          <img
            src={image}
            style={{ width: "100%", height: "100%", borderRadius: "10px" }}
          />
        </div>
        <div style={{ marginLeft: "16px", width: "130px" }}>
          <div className="shop-text">{brand}</div>
          <div className="medium-text" style={{ fontSize: "16px" }}>
            {name}
          </div>
          <div style={{ display: "flex" }}>
            <div className="price-text" style={{ fontSize: "16px" }}>
              {price?.toLocaleString()}원
            </div>
          </div>
        </div>
        <div style={{ marginLeft: "auto" }}>
          <IconCross
            style={{ cursor: "pointer" }}
            onClick={handleClickDeleteItem}
          />
        </div>
      </div>
      <div style={{ marginTop: "16px", marginLeft: "115px" }}>
        <PlusMinus
          value={_quantity}
          setValue={set_Quantity}
          updateQuantity={updateQuantity}
        />
      </div>
    </div>
  );
};

const GifticonBox = styled.div`
  width: auto;
  height: auto;
  min-height: 560px;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 20px;
  margin: 30px 30px 30px 30px;
  display: flex;
  position: relative;
  .medium-text {
    font-family: "notoSans-medium";
    color: #222222;
  }
  .bold-text {
    font-family: "notoSans-bold";
    color: #222222;
  }
  .shop-text {
    font-family: "notoSans-bold";
    font-size: 14px;
    color: #222222;
  }
  .sale-text {
    font-family: "notoSans-bold";
    font-size: 20px;
    color: #1167ed;
  }
  .price-text {
    font-family: "notoSans-bold";
    font-size: 20px;
    color: #222222;
  }

  .storage-btn {
    width: 347px;
    height: 24px;
    padding: 20px;
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  .shoppingBox {
    width: auto;
    height: auto;
    padding: 20px;
    border-radius: 20px;
    background-color: #ffffff;
    box-shadow: 0 0 0 1px #e4e4e4;
    margin-top: 14px;
  }
  .item-area {
    width: auto;
    height: auto;
    border-radius: 20px;
    background-color: #f5f5f5;
    font-family: "notoSans-medium";
    font-size: 14px;
    color: #888888;
    margin-top: 18px;
  }

  .empty-box {
    width: 1083px;
    height: 529px;
    color: #888888;
    margin-top: 10px;
  }

  .image-hover-box {
    width: 255.75px;
    height: 230px;
    background-color: rgba(0, 0, 0, 0.7);
    margin-top: -230px;
    opacity: 0;
    position: absolute;
    z-index: 3;
    &:hover {
      opacity: 1;
    }
  }
`;

const GifticonListBox = styled.div`
  width: 1083px;
  height: auto;
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  row-gap: 50px;
`;

const Gifticon = () => {
  return <Layout page={<GifticonContent />} />;
};

export default Gifticon;
